/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespComplementaryItemsGrid_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSimilarItemsFooter_item$ref: FragmentReference;
export type PdpRespSimilarItemsFooter_item = {|
  +isArt: ?boolean,
  +serviceId: ?string,
  +$fragmentRefs: PdpRespComplementaryItemsGrid_item$ref,
  +$refType: PdpRespSimilarItemsFooter_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsFooter_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isArt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespComplementaryItemsGrid_item",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd5a05d2479dd73a9dded3b023516f419';
module.exports = node;
